import { API_BASE } from './api-config';
import { useAuthStore } from '../stores/authStore';

export interface AskSource {
  id: string;
  collection: string;
  title: string;
  snippet: string;
}

export interface AskStreamResult {
  content?: string;
  sources?: AskSource[];
  error?: string;
}

export const askApi = {
  async *streamAsk(question: string): AsyncGenerator<AskStreamResult> {
    const token = useAuthStore.getState().token;
    if (!token) throw new Error('Not authenticated');

    const response = await fetch(`${API_BASE}/ask`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ question }),
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({ error: 'Request failed' })) as { error?: string };
      throw new Error(err.error ?? 'Request failed');
    }

    const reader = response.body?.getReader();
    if (!reader) throw new Error('No response body');

    const decoder = new TextDecoder();
    let buffer = '';

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop() ?? '';
      for (const line of lines) {
        if (line.startsWith('data: ')) {
          const data = line.slice(6);
          if (data === '[DONE]' || data === '') return;
          try {
            const parsed = JSON.parse(data) as AskStreamResult;
            if (parsed.error) throw new Error(parsed.error);
            yield parsed;
          } catch (e) {
            if (e instanceof Error && e.message !== '') throw e;
          }
        }
      }
    }
  },
};
